import React, { useEffect, useState } from "react";
import { Check, Clock3, FlaskConical, RefreshCw, Search, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { apiFetch } from "../../commons/axiosReq";
import "./MainAdminResearchAreaSuggestions.css";

const MainAdminResearchAreaSuggestions = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState("");
  const [message, setMessage] = useState("");

  const loadSuggestions = async () => {
    setLoading(true);
    const result = await apiFetch(`ResearchArea/Suggestions?status=Pending&search=${encodeURIComponent(search.trim())}`, "get");
    if (result.ok) {
      const data = result.data;
      const suggestions = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
      setItems(suggestions.map((item) => ({ ...item, suggestionId: item.suggestionId || item.researchAreaSuggestionId })));
      setMessage("");
    } else {
      setItems([]);
      setMessage(result.error || "دریافت پیشنهادها انجام نشد.");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!new Cookies().get("token")) navigate("/SignIn", { replace: true });
  }, [navigate]);

  useEffect(() => {
    loadSuggestions();
  }, [search]);

  const review = async (item, action) => {
    const id = item.suggestionId || item.researchAreaSuggestionId || item.id;
    if (!id) return;
    setBusyId(String(id));
    const result = await apiFetch(`ResearchArea/Suggestions/${id}/${action}`, "put", {});
    setBusyId("");
    if (!result.ok) return setMessage(result.error || "عملیات انجام نشد.");
    setItems((current) => current.filter((suggestion) => String(suggestion.suggestionId || suggestion.researchAreaSuggestionId || suggestion.id) !== String(id)));
    setMessage(action === "approve" ? "حوزه پژوهشی تأیید و به فهرست عمومی اضافه شد." : "پیشنهاد رد شد.");
  };

  return <div className="research-suggestions-page" dir="rtl">
    <header className="research-suggestions-header">
      <div className="research-suggestions-heading"><span><FlaskConical size={23} /></span><div><small>مدیریت محتوای تحصیلی</small><h1>پیشنهادهای حوزه پژوهشی</h1><p>پیشنهادهای کاربران را بررسی کنید و موارد مناسب را برای همه کاربران منتشر کنید.</p></div></div>
      <button type="button" className="research-suggestions-refresh" onClick={loadSuggestions}><RefreshCw size={17} />به‌روزرسانی</button>
    </header>
    <div className="research-suggestions-toolbar"><label><Search size={17} /><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="جستجو در نام حوزه یا رشته..." /></label><span><Clock3 size={15} />{items.length.toLocaleString("fa-IR")} پیشنهاد در انتظار بررسی</span></div>
    {message && <div className="research-suggestions-message">{message}</div>}
    {loading ? <div className="research-suggestions-state">در حال دریافت پیشنهادها...</div> : items.length === 0 ? <div className="research-suggestions-state"><FlaskConical size={34} /><strong>پیشنهاد در انتظاری وجود ندارد</strong><span>پیشنهادهای جدید کاربران در این بخش نمایش داده می‌شوند.</span></div> : <section className="research-suggestions-list">{items.map((item) => { const id = item.suggestionId || item.researchAreaSuggestionId || item.id; return <article key={id} className="research-suggestion-card"><div><small>حوزه پیشنهادی</small><h2>{item.name}</h2><p>رشته: <strong>{item.field?.name || item.fieldName || "ثبت نشده"}</strong></p>{(item.user?.name || item.userName || item.createdAt) && <p className="research-suggestion-meta">پیشنهاددهنده: {item.user?.name || item.userName || "کاربر"}{item.createdAt ? ` · ${new Date(item.createdAt).toLocaleDateString("fa-IR")}` : ""}</p>}</div><div className="research-suggestion-actions"><button type="button" className="is-reject" disabled={busyId === String(id)} onClick={() => review(item, "reject")}><X size={16} />رد</button><button type="button" className="is-approve" disabled={busyId === String(id)} onClick={() => review(item, "approve")}><Check size={16} />تأیید و انتشار</button></div></article>; })}</section>}
  </div>;
};

export default MainAdminResearchAreaSuggestions;
